<div class="scrolling-wrapper-flexbox">
  <ion-thumbnail class="card" *ngFor="let img of imgs; let i = index" (click)="handleImg(i)" (press)="tapImage(i)">
    <img src='../../../../assets/imgs/loader.gif' *ngIf="img.imgLoader || !imagesAvailible">
    
    <img [hidden]="img.imgLoader" *ngIf="img.path" [src]="img.path" [ngClass]="{'unavailable': !imagesAvailible}"
      (load)="img.imgLoader = false">

    <img [hidden]="img.imgLoader || !imagesAvailible" *ngIf="img.url" [src]="img.icon || img.url"
      (load)="img.imgLoader = false">
  </ion-thumbnail>
</div>